import React from 'react';

export function ViewFooter({
  children,
  ...props
}) {
  return (
    <div className="view-footer" {...props}>{children}</div>
  )
}